module.exports = __webpack_public_path__ + "img/tornoment.bec600d2.png";